<fury-page-layout mode="card">
  <fury-page-layout-header>
    <div class="top_heading">
        <fury-breadcrumbs [@fadeInRight] [current]="'Add Claim'"></fury-breadcrumbs>
        <button mat-button class="can-button" (click)="location.back()"><mat-icon>keyboard_backspace</mat-icon> Back</button>
    </div>
</fury-page-layout-header>
  <fury-page-layout-content [@fadeInUp]>
    <div class="two_section">
      <div class="customer_leftinfo">
        <fury-customer-side-menu ></fury-customer-side-menu>
      </div>
      <div class="righpanel">
        <div class="stepperprt">
    
          <!-- For First Step -->
            <div class="step__wrap">
              <div class="midprt" *ngIf="step == 0 && fileClaimSubSteps === fileClaimSubStep.landingPage">
                <div class="ftstep">
                  <h2 class="heading main__heading">
                    Breakdowns happen. We are here to help.
                  </h2>
                  
                  <h3>
                    Do what you love. We take care of where you live.
                  </h3>
                  <p>
                    Please complete the following claim form to request service. A claims concierge will be in touch with you shortly.
                  </p>
                  <button class="planbtn getstr" (click)="step = 0; fileClaimSubSteps = fileClaimSubStep.AgreementGridPage">
                    GET STARTED <mat-icon> arrow_forward</mat-icon>
                  </button>
                </div>
              </div>

              <div class="midprt" *ngIf="step == 0 && fileClaimSubSteps === fileClaimSubStep.AgreementGridPage">
                <h2 style="text-align: left;">Agreements</h2>
                <fury-agreements-table
                    [displayedColumns]="displayedColumns"
                    [dataSource]="dataSource"
                    (getRowData)="getAgreementNumber($event)"
                  ></fury-agreements-table>
                  <mat-paginator
                    *ngIf="this.totalCount > 0"
                    [pageSizeOptions]="[30, 50, 100, 9999]"
                    [pageSize]="pageSize"
                    [length]="totalCount"
                    [pageIndex]="pageIndex"
                    (page)="pageSizeChange($event)"
                    showFirstLastButtons
                    [selectConfig]="selectConfig"
                    [ngClass]="{ 'mat-pegig': pageSize === 9999 }"
                    aria-label="Select page of periodic elements"
                  >
                  </mat-paginator>
                <div class="btnpart">
                  <button class="planbtn cancel" (click)="fileClaimSubSteps = fileClaimSubStep.landingPage">
                    BACK
                  </button>
                  <!-- <button type="submit" class="planbtn mobshownone" (click)="step = 0; fileClaimSubSteps = fileClaimSubStep.AgreementNumberPage">
                    Continue
                  </button> -->
                </div>
              </div>
        
              <!-- Agreement Number Step -->
              <div class="step" *ngIf="step == 0 && fileClaimSubSteps === fileClaimSubStep.AgreementNumberPage">
                <form [formGroup]="agreementNumberForm">
                  <p>What is your service agreement number?</p>
                  <div class="fieldwrap">
                      <div class="fieldprt fullwidth">
                          <input type="text" placeholder="Enter your agreement number" formControlName="agreementNumber">
                          <button (click)="openFindAgreementModal()" class="agreement_num">Find Agreement Number</button>
                          <mat-error *ngIf="agreementNumberForm.controls['agreementNumber'].touched && agreementNumberForm.controls['agreementNumber'].hasError('required')">
                            This is required
                          </mat-error>
                          <mat-error *ngIf="agreementNumberForm.controls['agreementNumber'].touched && agreementNumberForm.controls['agreementNumber'].hasError('maxlength')">
                            Maximum length should be 7.
                          </mat-error>
                      </div>
                      <div class="btnpart">
                        <button class="planbtn cancel" (click)="fileClaimSubSteps = fileClaimSubStep.AgreementGridPage">
                          BACK
                        </button>
                        <button type="submit" class="planbtn mobshownone" (click)="checkAgreementNumberForm()">
                          Continue
                        </button>
                      </div>
                  </div>
                </form>
        
        
              </div>
              
              <!-- STEP 1 -->
              <div class="midprt" [style.display]="step == 1 ? 'flex' : 'none'">
                <div class="step">
                  <form [formGroup]="addressForm">
                    <h2 class="heading main__heading">
                      Breakdowns happen. We are here to help.
                    </h2>
                    <h3>
                      Do what you love. We take care of where you live.
                    </h3>
                    <p *ngIf="!submitFullForm">
                      What’s the address of the covered property?
                    </p>
                    <p *ngIf="submitFullForm">
                      Please provide your contact information?
                    </p>
                    <div class="fieldwrap form_area" style="margin-bottom: -10px;">
                      <div class="fieldprt fullwidth" [style.display]="!showZipcodeField ? 'block' : 'none'">
                        <input type="text" formControlName="address" placeholder="What is your Home Address?" #homeAddress  [readOnly]="!showZipcodeField && submitFullForm" >
                        <div class="matcheck" *ngIf="submitFullForm && addressForm.controls['address'].valid">
                          <span><i class="material-icons">check</i></span>
                        </div>
                        <div class="change_address" (click)="changeAddress()" *ngIf="submitFullForm && addressForm.controls['address'].valid">Change Address</div>
                        <mat-error *ngIf="addressForm.controls['address'].touched && addressForm.controls['address'].hasError('required')">
                            This is required
                        </mat-error>
                       
                      </div>
                    
                      <div class="fieldprt fullwidth" *ngIf="showZipcodeField && !submitFullForm">
                        <input type="text" placeholder="What is your Zip code?" formControlName="zip" mask="00000" />
                        <div class="matcheck" *ngIf="addressForm.controls['zip'].valid">
                          <span><i class="material-icons">check</i></span>
                        </div>
                        <div class="matcheck" *ngIf="submitFullForm">
                          <span><i class="material-icons">check</i></span>
                        </div>
                        <mat-error *ngIf="addressForm.controls['zip'].touched && addressForm.controls['zip'].hasError('required')">
                            This is required
                        </mat-error>
                        <mat-error *ngIf="addressForm.controls['zip'].hasError('notValid')">
                          Please enter valid zip.
                      </mat-error>
                        <a class="gobackzip" *ngIf="!submitFullForm" (click)="goBackToAddressSection()">
                          <mat-icon>arrow_back</mat-icon> Go Back
                        </a>
                      </div>
                      <div class="btnpart">
                          <button *ngIf="!submitFullForm && !agreementNumber" (click)="step = 0; fileClaimSubSteps = fileClaimSubStep.AgreementNumberPage" class="planbtn cancel">Back</button>
                          <button *ngIf="!submitFullForm && !showZipcodeField" [disabled]="!addressForm.controls['address'].value" (click)="checkAddress()" class="planbtn" >Next</button>
                          <button (click)="checkZipAndProceed()" class="planbtn" [disabled]="!addressForm.controls['zip'].valid" *ngIf="showZipcodeField">Next</button>
                      </div>
                    
                    </div>
                    
                    <div class="fieldwrap" *ngIf="submitFullForm"> 
                      
                      <div class="fieldprt">
                        <input type="text" 
                        placeholder="First Name"
                        formControlName="firstName" 
                        (keyup)="apiService.restrictSpace($event)"
                        (keypress)="apiService.allowAlphabate($event)"
                        />
                        <div class="matcheck" *ngIf="addressForm.controls['firstName'].valid">
                          <span><i class="material-icons">check</i></span>
                        </div>
                        <mat-error *ngIf="addressForm.controls['firstName'].touched && addressForm.controls['firstName'].hasError('required')">
                            This is required
                        </mat-error>
                            <mat-error *ngIf="
                                addressForm.controls['firstName'].touched && addressForm.controls['firstName'].hasError('minlength')">
                              Please enter a valid first name.
                            </mat-error>
                        
                      </div>
                      <div class="fieldprt">
                        <input type="text" 
                        formControlName="lastName"
                        placeholder="Last Name"
                        (keyup)="apiService.restrictSpace($event)" 
                        (keypress)="apiService.allowAlphabate($event)"
                        />
                        <div class="matcheck" *ngIf="addressForm.controls['lastName'].valid">
                          <span><i class="material-icons">check</i></span>
                        </div>
                        <mat-error *ngIf="addressForm.controls['lastName'].touched &&  addressForm.controls['lastName'].hasError('required')">
                          This is required
                        </mat-error>
                        <mat-error *ngIf="addressForm.controls['lastName'].touched && addressForm.controls['lastName'].hasError('minlength')">
                          Please enter a valid last name.
                        </mat-error>
                      </div>
                      <div class="fieldprt">
                        <input type="text" formControlName="phoneNumber" placeholder="Phone Number" mask="(000) 000-0000"/>
                        <div class="matcheck" *ngIf="addressForm.controls['phoneNumber'].valid">
                          <span><i class="material-icons">check</i></span>
                        </div>
                        <mat-error>
                          <p *ngIf="addressForm.controls['phoneNumber'].touched && addressForm.controls['phoneNumber'].hasError('required')">
                            This is required
                          </p>
                          <p *ngIf="
                              addressForm.controls['phoneNumber'].touched &&
                              !addressForm.controls['phoneNumber'].hasError('required') &&
                              addressForm.controls['phoneNumber'].hasError('pattern')
                            ">
                            Enter a correct phone number
                          </p>
                          <p *ngIf="addressForm.controls['phoneNumber'].hasError('notValid')">
                            Please enter an active phone number
                          </p>
                        </mat-error>
                        
                      </div>
                      <div class="fieldprt">
                        <input type="text" formControlName="emailAddress" placeholder="Email Address" (keyup)="changeEmailAndSet()" />
                        <div class="matcheck" *ngIf="addressForm.controls['emailAddress'].valid">
                          <span><i class="material-icons">check</i></span>
                        </div>
                        <mat-error>
                          <p *ngIf="
                              addressForm.controls['emailAddress'].touched &&
                              addressForm.controls['emailAddress'].hasError('required')
                            ">
                            This is required
                          </p>
                          <p *ngIf="addressForm.controls['emailAddress'].hasError('pattern')">
                            Email is not valid
                          </p>
                          <p *ngIf="addressForm.controls['emailAddress'].hasError('notValidEmail')">
                            Please enter an active email address
                          </p>
                        </mat-error>
                       
                      </div>
                      <div class="btnpart">
                        <button class="planbtn mobshownone" [disabled]="!addressForm.valid" (click)="submitFirstStep()">
                          Continue
                        </button>
                      </div>
                    </div>
                  </form>
                 </div> 
              </div>
              <!-- STEP 2 ,, Sub-Step 1 -->
               <div class="midprt" [style.display]="step == 2 && subStepTwo == 1 && !showFirstQuestionForm ? 'flex' : 'none'">
                    <div class="step">
                     
                      <form [formGroup]="coverItemForm">
                        <h4>Which item is not working properly?</h4>
                        <div class="fieldwrap">
                          <div class="fieldprt fullwidth">
                            
                            <select formControlName="coveredItemId" (change)="coverItemChange($event)" placeholder="Select Items">
                              <option value="">Please select an option</option>
                              <option *ngFor="let item of coverItems" [value]="item?.planCoverItemId">
                                  {{item?.title}}
                              </option>
                            </select>
                            <mat-error *ngIf="coverItemForm.controls['coveredItemId'].touched && coverItemForm.controls['coveredItemId'].hasError('required')">
                              This is required
                            </mat-error>
                            <mat-error *ngIf="coverItemForm.controls['coveredItemId'].touched && coverItemForm.controls['coveredItemId'].hasError('notValid')">
                              Please select another cover item.
                            </mat-error>
                              
                          </div>
                          <div class="fieldprt fullwidth" *ngIf="showSubCoverItem">
                            <h4>Select Item Type</h4>
                            <select formControlName="subCoveredItemId" (change)="subCoverItemChange($event)" placeholder="Select Items">
                              <option value="">Please select an option</option>
                              <option *ngFor="let item of subCoverItems" [value]="item?.planSubCoverItemId">
                                  {{item?.title}}
                              </option>
                            </select>
                            <mat-error *ngIf="coverItemForm.controls['subCoveredItemId'].touched && coverItemForm.controls['subCoveredItemId'].hasError('required')">
                              This is required
                            </mat-error>
                            <mat-error *ngIf="coverItemForm.controls['subCoveredItemId'].touched && coverItemForm.controls['subCoveredItemId'].hasError('notValid')">
                              Please select another sub covered item.
                            </mat-error>
                            <p *ngIf="subCoverItemDetails && !subCoverItemDetails?.isCovered">{{subCoverItemDetails?.title}} is not covered</p>
                              
                          </div>
                          <div class="fieldprt fullwidth" *ngIf="showSubCoverItemChild">
                            <h4>Select an Option</h4>
                            <select formControlName="subCoveredItemChildId" (change)="subCoverItemChildChange($event)" placeholder="Select Items">
                              <option value="">Please select an option</option>
                              <option *ngFor="let item of subCoverItemChild" [value]="item?.planSubCoverItemId">
                                  {{item?.title}}
                              </option>
                            </select>
                            <mat-error *ngIf="coverItemForm.controls['subCoveredItemChildId'].touched && coverItemForm.controls['subCoveredItemChildId'].hasError('required')">
                              This is required
                            </mat-error>
                            <mat-error *ngIf="coverItemForm.controls['subCoveredItemChildId'].touched && coverItemForm.controls['subCoveredItemChildId'].hasError('notValid')">
                              Please select another sub covered item.
                            </mat-error>
                            <p *ngIf="subCoverChildDetais && !subCoverChildDetais?.isCovered">{{subCoverChildDetais?.title}} is not covered</p>
                              
                          </div>
                          <div class="btnpart">
                            <button class="planbtn cancel" (click)="back()">
                              BACK
                            </button>
                            <button type="submit" class="planbtn mobshownone" (click)="checkSubSecondStepOne()" [disabled]="counter < 4" *ngIf="!loading">
                              Continue
                            </button>
                            <img [ngSrc]="assetsUrl + 'loder.gif'" alt="loaderImg" width="150" height="30" class="loadimg" *ngIf="loading" />
                          </div>
                        </div>
                        
                      </form>
                    </div>
               </div>
        
               <!-- Step 2,, for First Question -->
               <div class="midprt" [style.display]="step == 2 && subStepTwo == 1 && showFirstQuestionForm ? 'flex' : 'none'">
                <div class="step">
                  <form [formGroup]="firstQuestionsForm">
                    <div class="queryprt">
                      <div class="textQues" *ngFor="let question of firstQuestions;let i = index">
                        <ng-container  *ngIf="isCurrentQuestion(i)">
                          <h4>{{ question.title }}</h4>
                          <div *ngIf="question.type === 'Text Input'" class="text_input">
                            <input type="text" placeholder="Enter question" [formControlName]="question.firstQuestionId">
                            <mat-error
                              *ngIf="firstQuestionsForm.controls[question.firstQuestionId]?.touched && firstQuestionsForm.controls[question.firstQuestionId].hasError('required')">
                              This is required
                            </mat-error>
                          </div>
                          <div class="radioprt" *ngIf="question.type === 'Yes/No'">
                            <div>
                              <span><input type="radio" [formControlName]="question.firstQuestionId" [value]="true"> Yes</span>
                              <span><input type="radio" [formControlName]="question.firstQuestionId" [value]="false"> No</span>
                            </div>
                            <mat-error
                              *ngIf="firstQuestionsForm.controls[question.firstQuestionId]?.touched && firstQuestionsForm.controls[question.firstQuestionId].hasError('required')">
                              This is required
                            </mat-error>
                          </div>
                          
                          <div class="text_input" *ngIf="question.type === 'Dropdown'">
                            <select [formControlName]="question.firstQuestionId">
                              <option value="">Please select an option</option>
                              <option *ngFor="let option of question?.options" [value]="option">{{option}}</option>
                            </select>
                            <mat-error
                              *ngIf="firstQuestionsForm.controls[question.firstQuestionId]?.touched && firstQuestionsForm.controls[question.firstQuestionId].hasError('required')">
                              This is required
                            </mat-error>
                          </div>
                        </ng-container>
                        
                      </div>
                    </div>
          
                    <div class="btnpart">
                      <button class="planbtn cancel" (click)="checkFirstQuestionFormBack()">
                        BACK
                      </button>
                      <button class="planbtn mobshownone" (click)="checkFirstQuestionFormContinue()">
                        Continue
                      </button>
                    </div>
                  </form>
                </div>
              </div>
        
               <div class="steeperprt" [style.display]="step > 1 && step < 5 && subStepTwo > 1 ? 'block' : 'none'">
                <h4>
                  Please provide the following details regarding the issue you are having.
                </h4>
                <div class="sideprt">
                        <div class="left-side">
                          <!-- STEP 2 -->
                          <div class="formfullcont" [style.display]="step == 2 ? 'block' : 'none'">
                            
                            <div class="formfullcont" [style.display]="step == 2 && subStepTwo > 1 ? 'block' : 'none'">
                              <div class="formfullcont">
                                  <!-- Sub Step 2 -->
                                  <div class="file_cont" [style.display]="step == 2 && subStepTwo == 2 ? 'block' : 'none'">
                              
                                    <h3>
                                      Request Service
                                    </h3>
                                    <div class="form_prt">
                                      <form [formGroup]="beforeQuestionForm">
                                        <div class="queryprt">
                                          <div class="questioprt" *ngFor="let question of beforeQuestion; index as i">
                                            <label>{{ question.title }}</label>
                                            <div *ngIf="question.type === 'Text Input'" class="text_input">
                                              <input type="text" placeholder="Please provide details" [formControlName]="question.additionalQuestionId">
                                              <mat-error
                                                *ngIf="beforeQuestionForm.controls[question.additionalQuestionId]?.touched && beforeQuestionForm.controls[question.additionalQuestionId].hasError('required')">
                                                This is required
                                              </mat-error>
                                            </div>
                                            <div class="radioprt" *ngIf="question.type === 'Yes/No'">
                                              <div>
                                                <span><input type="radio" [formControlName]="question.additionalQuestionId" [value]="true" (change)="checkeAdditianalQuestion(true, question.additionalQuestionId,'beforeQuestion', i); checkReflectedPriceYesNoQuestion('beforeQuestion', question.additionalQuestionId, true)"> Yes</span>
                                                <span><input type="radio" [formControlName]="question.additionalQuestionId" [value]="false" (change)="checkeAdditianalQuestion(false, question.additionalQuestionId, 'beforeQuestion', i); checkReflectedPriceYesNoQuestion('beforeQuestion', question.additionalQuestionId, false)"> No</span>
                                              </div>
                              
                                              <mat-error
                                                *ngIf="beforeQuestionForm.controls[question.additionalQuestionId]?.touched && beforeQuestionForm.controls[question.additionalQuestionId].hasError('required')">
                                                This is required
                                              </mat-error>
                                            </div>
                                            <!-- <div *ngIf="question.type === 'Date'" class="text_input">
                                              <input type="date" [formControlName]="question.additionalQuestionId" [attr.max]="maxDate">
                                              <mat-error
                                                *ngIf="beforeQuestionForm.controls[question.additionalQuestionId]?.touched && beforeQuestionForm.controls[question.additionalQuestionId].hasError('required')">
                                                This is required
                                              </mat-error>
                                            </div> -->
                                            <div *ngIf="question.type === 'Date'" class="text_input datapick">
                                              <mat-form-field class="example-full-width" appearance="outline">
                                                  <!-- <mat-label>Closing Date</mat-label> -->
                                                  <input matInput [matDatepicker]="picker" [formControlName]="question.additionalQuestionId" [max]="maxDate" (click)="picker.open()" [readonly]="true" placeholder="Select date">
                                                  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                                                  <mat-datepicker #picker></mat-datepicker>
                                              </mat-form-field>
                                              <mat-error
                                                *ngIf="beforeQuestionForm.controls[question.additionalQuestionId]?.touched && beforeQuestionForm.controls[question.additionalQuestionId].hasError('required')">
                                                This is required
                                              </mat-error>
                                          </div>
                                            <div *ngIf="question.type === 'Dropdown'" class="text_input">
                                              <select [formControlName]="question.additionalQuestionId" (change)="checkReflectedPriceDropDownQuestion('beforeQuestion', question.additionalQuestionId, $event)">
                                                <option value="">Please select an option</option>
                                                <option *ngFor="let option of question?.options" [value]="option?.option">{{option?.option}}</option>
                                              </select>
                                              <mat-error
                                                *ngIf="beforeQuestionForm.controls[question.additionalQuestionId]?.touched && beforeQuestionForm.controls[question.additionalQuestionId].hasError('required')">
                                                This is required
                                              </mat-error>
                                            </div>
                                          </div>
                                        </div>
                              
                                        <div class="btnpart">
                                          <button class="planbtn cancel" (click)="beforeQuestionBack()">
                                            BACK
                                          </button>
                                          <button class="planbtn mobshownone" (click)="checkSubSecondStepTwo()">
                                            Continue
                                          </button>
                                        </div>
                                      </form>
                              
                              
                                    </div>
                                  </div>
                                  <!-- Sub Step 3 -->
                                  <div class="file_cont"  [style.display]="step == 2 && subStepTwo == 3 ? 'block' : 'none'">
                              
                                    <h3>
                                      Details of the Issue
                                    </h3>
                                    <div class="form_prt">
                                      <form [formGroup]="claimQuestionForm">
                                        <div class="queryprt">
                                          <div class="claimfield">
                              
                                            <ng-container *ngFor="let item of claimQuestion">
                                              <div class="halfwidth">
                                                <label>{{item?.question?.question}}</label>
                                                <ul>
                                                  <li *ngFor="let subItem of item?.questionAnswers">
                                                    <input type="checkbox"
                                                           
                                                           (change)="toggleAnswer(item.question.claimQuestionId, subItem.answer.claimQuestionAnswerId, $event)" />
                                                    <label>{{ subItem?.answer?.answer }}</label>
                                                  </li>
                                                  <li  class="others">
                                                    <input type="checkbox"
                                                           (change)="toggleAnswer(item.question.claimQuestionId, 'others', $event)" />
                                                    <label>Others</label>
                                                  </li>
                                                </ul>
                                                
                                                <mat-error
                                                      *ngIf="claimQuestionForm.controls[item?.question.claimQuestionId]?.touched && claimQuestionForm.controls[item?.question.claimQuestionId].hasError('required')">
                                                      This is required
                                                    </mat-error>
                                              </div>
                                            </ng-container>
                                            <div class="Other-question" *ngIf="isOtherAnswer">
                                              <form [formGroup]="otherAnswerForm">
                                              
                                                  <div class="questioprt">
                                                    <label>Please enter your other answer</label>
                                                    <div class="text_input">
                                                    <input type="text" formControlName="otherAnswer">
                                                    <mat-error
                                                    *ngIf="otherAnswerForm.controls['otherAnswer']?.touched && otherAnswerForm.controls['otherAnswer'].hasError('required')">
                                                    This is required
                                                    </mat-error>
                                                  </div>
                                                  </div>
                                              
                                                
                                              </form>
                                            </div>
                                            <div class="issue_date">
                                              <form [formGroup]="issueDateForm">
                                                <div class="questioprt">
                                                  <label>When did you first notice the issue?</label>
                                                  <div class="text_input datapick">
                                                  <!-- <input type="date" formControlName="issueDate" [attr.max]="maxDate"> -->
                                                  <mat-form-field class="example-full-width" appearance="outline">
                                                    <!-- <mat-label>Closing Date</mat-label> -->
                                                    <input matInput formControlName="issueDate" [matDatepicker]="picker" [max]="maxDate" (click)="picker.open()" [readonly]="true" placeholder="Select date">
                                                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                                                    <mat-datepicker #picker></mat-datepicker>
                                                </mat-form-field>
                                                  <mat-error
                                                  *ngIf="issueDateForm.controls['issueDate']?.touched && issueDateForm.controls['issueDate'].hasError('required')">
                                                  This is required
                                                  </mat-error>
                                                </div>
                                                </div>
                                              </form>
                                            </div>
                                          </div>
                                        </div>
                              
                              
                              
                                        <div class="btnpart">
                                          <button class="planbtn cancel" (click)="checkClaimQuestionBack()">
                                            BACK
                                          </button>
                                          <button class="planbtn mobshownone" (click)="checkSubSecondStepThree()">
                                            Continue
                                          </button>
                                        </div>
                                      </form>
                                    </div>
                              
                                  </div>
                                  <!-- Sub Step 4 -->
                                  <div class="file_cont" [style.display]="step == 2 && subStepTwo == 4 ? 'block' : 'none'">
                              
                                    <h3>
                                      Additional Information is Needed
                                    </h3>
                                    <div class="form_prt">
                                      <form [formGroup]="afterQuestionForm">
                                        <div class="queryprt">
                                          <div class="questioprt" *ngFor="let question of afterQuestion; index as i">
                                            <label>{{ question.title }}</label>
                                            <div *ngIf="question.type === 'Text Input'" class="text_input">
                                              <input type="text" placeholder="Please provide details" [formControlName]="question.additionalQuestionId">
                                              <mat-error
                                                *ngIf="afterQuestionForm.controls[question.additionalQuestionId]?.touched && afterQuestionForm.controls[question.additionalQuestionId].hasError('required')">
                                                This is required
                                              </mat-error>
                                            </div>
                                            <div class="radioprt" *ngIf="question.type === 'Yes/No'">
                                              <div>
                                                <span><input type="radio" [formControlName]="question.additionalQuestionId" [value]="true" (change)="checkeAdditianalQuestion(true, question.additionalQuestionId, 'afterQuestion', i); checkReflectedPriceYesNoQuestion('afterQuestion', question.additionalQuestionId, true)"> Yes</span>
                                                <span><input type="radio" [formControlName]="question.additionalQuestionId" [value]="false" (change)="checkeAdditianalQuestion(false, question.additionalQuestionId, 'afterQuestion', i); checkReflectedPriceYesNoQuestion('afterQuestion', question.additionalQuestionId, false)"> No</span>
                                              </div>
                              
                                              <mat-error
                                                *ngIf="afterQuestionForm.controls[question.additionalQuestionId]?.touched && afterQuestionForm.controls[question.additionalQuestionId].hasError('required')">
                                                This is required
                                              </mat-error>
                                            </div>
                                            <!-- <div *ngIf="question.type === 'Date'" class="text_input">
                                              <input type="date" [formControlName]="question.additionalQuestionId" [attr.max]="maxDate">
                                              <mat-error
                                                *ngIf="afterQuestionForm.controls[question.additionalQuestionId]?.touched && afterQuestionForm.controls[question.additionalQuestionId].hasError('required')">
                                                This is required
                                              </mat-error>
                                            </div> -->
                                            <div  *ngIf="question.type === 'Date'" class="text_input datapick">
                                              <mat-form-field class="example-full-width" appearance="outline">
                                                  <!-- <mat-label>Closing Date</mat-label> -->
                                                  <input matInput [matDatepicker]="picker" [formControlName]="question.additionalQuestionId" [max]="maxDate" (click)="picker.open()" [readonly]="true" placeholder="Select date">
                                                  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                                                  <mat-datepicker #picker></mat-datepicker>
                                              </mat-form-field>
                                              <mat-error
                                                *ngIf="afterQuestionForm.controls[question.additionalQuestionId]?.touched && afterQuestionForm.controls[question.additionalQuestionId].hasError('required')">
                                                This is required
                                              </mat-error>
                                          </div>
                                            <div *ngIf="question.type === 'Dropdown'" class="text_input">
                                              <select [formControlName]="question.additionalQuestionId" (change)="checkReflectedPriceDropDownQuestion('afterQuestion', question.additionalQuestionId, $event)">
                                                <option value="">Please select an option</option>
                                                <option *ngFor="let option of question?.options" [value]="option?.option">{{option.option}}</option>
                                              </select>
                                              <mat-error
                                                *ngIf="afterQuestionForm.controls[question.additionalQuestionId]?.touched && afterQuestionForm.controls[question.additionalQuestionId].hasError('required')">
                                                This is required
                                              </mat-error>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="btnpart">
                                          <button class="planbtn cancel" (click)="subStepTwo = 3; step = 2">
                                            BACK
                                          </button>
                                          <button class="planbtn mobshownone" (click)="checkSubSecondStepFore()">
                                            Continue
                                          </button>
                                        </div>
                                      </form>
                                    </div>
                              
                              
                                  </div>
                                </div>
                               
                            </div>
                          </div>  
        
                        <!-- STEP 3 -->
                        <div class="timerprt" [style.display]="step == 3 ? 'flex' : 'none'">
                          <h4>Please provide your availability for the upcoming days?</h4>
                          
                            <div>
                              <form [formGroup]="timeForm">
                                <div class="radiopanel">
                                  <div>
                                      <div class="upcoming_radio">
                                        <span>
                                          <input type="radio" formControlName="availability" value="Mornings 7 to 11 AM" (change)="redioChange($event)"/>
                                          <label>
                                            Mornings 7 to 11 AM
                                          </label>
                                          
                                        </span>
                                        <span>
                                          <input type="radio" formControlName="availability" value="Afternoons 12 to 3 PM" (change)="redioChange($event)" />
                                          <label>
                                            Afternoons 12 to 3 PM
                                          </label>
                                          
                                        </span>
                                        <span>
                                          <input type="radio" formControlName="availability" value="Evenings 4 to 6 PM" (change)="redioChange($event)" />
                                          <label>
                                            Evenings 4 to 6 PM
                                          </label>
                                          
                                        </span>
                                        <span>
                                          <input type="radio" formControlName="availability" value="After Hours: 6 - 10 PM" (change)="redioChange($event)"/>
                                          <label>
                                            After Hours: 6 - 10 PM
                                          </label>
                                        </span>
                                      </div>
                                      <mat-error *ngIf="timeForm.controls['availability'].touched && timeForm.controls['availability'].hasError('required')">
                                        This is required
                                      </mat-error>
                                  </div>
                                  <div class="ammount" *ngIf="timeForm.controls['copaymentFee'].value">
                                    <b>
                                      Copayment Fee ${{timeForm.controls['copaymentFee'].value}}
                                    </b>
                                  </div>
                                </div>
                                
                                <div class="btnpart">
                                  <button class="planbtn cancel" (click)="step = 2">
                                    BACK
                                  </button>
                                  <button class="planbtn mobshownone" (click)="checkTimeForm()">
                                    Continue
                                  </button>
                                </div>
                                
                              </form>
                            </div>
                            
                            
                          
                        
                            
                        </div>
        
        
                    <!-- STEP 4 -->
                          <div class="timerprt" [style.display]="step == 4 ? 'flex' : 'none'">
                            
                              <h4>Please provide your payment information for the copayment fee.</h4>
                            
                                <div>
                                  <form [formGroup]="cardDetailsForm">
                                    <div class="mainpanelpayment">
                                      <div class="paymentsec">
                                        <div class="fieldwrap">
                                          <div class="fieldprt fullwidth">
                                          <label class="label">Select a card</label>
                                          <select formControlName="cardPayment" (change)="onCardChange($event)">
                                              <option *ngFor="let card of creditCardList" [value]="card?.cardDetails?.cardNumber">XXXX XXXX XXXX {{card?.cardDetails?.cardNumber.slice(-4)}}</option>
                                              <option value="">Add Card</option>
                                          </select>
                                            <mat-error
                                              *ngIf="cardDetailsForm.controls['cardPayment'].touched && cardDetailsForm.controls['cardPayment'].hasError('required')">
                                              This is required
                                            </mat-error>
                                          </div>
                                          <div class="fieldprt fullwidth">
                                            <input type="text" placeholder="Card Number" formControlName="cardNumber"
                                            [hiddenInput]="true"
                                            [mask]="
                                            cardType == 'American Express'
                                              ? 'XXXX XXXXXX X0000'
                                              : 'XXXX XXXX XXXX 0000'
                                          " (ngModelChange)="detectCardType($event)" [readOnly]="cardDetailsForm.get('cardPayment').value"/>
                                            <span *ngIf="cardType && cardType == 'Visa'" class="cardlogo">
                                              <img src="https://cdn.elitehw.com/images/visa-card-logo.png" alt="">
                                            </span>
                                            <span *ngIf="cardType && cardType == 'Mastercard'" class="cardlogo mastercard">
                                              <img src="https://cdn.elitehw.com/images/master-card.png" alt="">
                                            </span>
                                            <span *ngIf="cardType && cardType == 'American Express'" class="cardlogo">
                                              <img src="https://cdn.elitehw.com/images/American-Express.png" alt="">
                                            </span>
                                            <span *ngIf="cardType && cardType == 'Discover'" class="cardlogo">
                                              <img src="https://cdn.elitehw.com/images/discover.png" alt="">
                                            </span>
                                            <mat-error
                                              *ngIf="cardDetailsForm.controls['cardNumber'].touched && cardDetailsForm.controls['cardNumber'].hasError('required')">
                                              This is required
                                            </mat-error>
                                            <mat-error
                                              *ngIf="cardDetailsForm.controls['cardNumber'].touched && cardDetailsForm.controls['cardNumber'].hasError('mask')">
                                              Enter Valid Card Number
                                            </mat-error>
                                          </div>
                                        
                                          <div class="fieldprt">
                                            <input type="text" placeholder="Expiration Date" formControlName="monthYear" mask="00/00" [readOnly]="cardDetailsForm.get('cardPayment').value" />
                                            <mat-error
                                              *ngIf="cardDetailsForm.controls['monthYear'].touched && cardDetailsForm.controls['monthYear'].hasError('required')">
                                              This is required
                                            </mat-error>
                                            <mat-error
                                              *ngIf="cardDetailsForm.controls['monthYear'].touched && cardDetailsForm.controls['monthYear'].hasError('mask')">
                                              Enter valid expiration date.
                                            </mat-error>
                                            <mat-error
                                              *ngIf="cardDetailsForm.controls['expiryMonth'].touched && cardDetailsForm.controls['expiryMonth'].hasError('max') && !cardDetailsForm.controls['monthYear'].hasError('mask')">
                                              Enter Valid Expiration Month.
                                            </mat-error>
                                            <mat-error
                                              *ngIf="cardDetailsForm.controls['expiryMonth'].touched && cardDetailsForm.controls['expiryMonth'].hasError('min') && !cardDetailsForm.controls['monthYear'].hasError('mask')">
                                              Expiration Month value should be greater then 0.
                                            </mat-error>
                                            <mat-error
                                              *ngIf="cardDetailsForm.controls['expiryYear'].touched && cardDetailsForm.controls['expiryYear'].hasError('min') && !cardDetailsForm.controls['monthYear'].hasError('mask')">
                                              Enter Valid Expiration Year.
                                            </mat-error>
                                            <mat-error *ngIf="
                                            !cardDetailsForm.controls['monthYear'].hasError('required') && 
                                            cardDetailsForm.controls['expiryMonth'].hasError('notValid') && 
                                            !cardDetailsForm.controls['monthYear'].hasError('mask') &&
                                            cardDetailsForm.controls['monthYear'].touched &&
                                            !cardDetailsForm.controls['expiryYear'].hasError('min')">
                                                Enter Valid Expire Month.
                                          </mat-error>
                                          </div>
                                        
                                          <div class="fieldprt rightfield">
                                            <input type="text" placeholder="CVV Code" formControlName="cvv"  [hiddenInput]="true" [hiddenInput]="true"  [mask]="cardType == 'American Express' ? 'XXXX' : 'XXX'" [readOnly]="cardDetailsForm.get('cardPayment').value"/>
                                            <mat-error *ngIf="cardDetailsForm.controls['cvv'].touched && cardDetailsForm.controls['cvv'].hasError('required')">
                                              This is required
                                            </mat-error>
                                            <mat-error *ngIf="cardDetailsForm.controls['cvv'].touched && cardDetailsForm.controls['cvv'].hasError('mask')">
                                              Enter valid cvv code.
                                            </mat-error>
                                          </div>
                                        </div>
                                    </div>
                                    </div>
                                    
                              
                                    <div class="btnpart">
                                      <button class="planbtn cancel" (click)="step = 3" [disabled]="loading">
                                        BACK
                                      </button>
                                      <button class="planbtn mobshownone" (click)="checkCardDetails()" *ngIf="!loading">
                                        Continue
                                      </button>
                                      <img [ngSrc]="assetsUrl + 'loder.gif'" alt="loaderImg" width="150" height="30" class="loadimg" *ngIf="loading" />
        
                                    </div>
                              
                                  </form>
                                </div>
                          </div>
                        </div>
                      <div class="right-side" [style.display]="step > 1  && subStepTwo > 1 ? 'block' : 'none'" >
                          <div class="topheading">
                            <h3>
                              Claim Summary
                            </h3>
                          </div>
                          <div class="inner_rightsidecont">
                            <div class="contdetailprt">
                              <h4>
                                Contact Details
                              </h4>
                              <span>
                                <label>
                                  Name:
                                </label>
                                <p>
                                  {{addressForm.value?.firstName}} {{addressForm.value?.lastName}}
                                </p>
                              </span>
                              <span>
                                <label>
                                  Email:
                                </label>
                                <p class="addressbreak">
                                  {{addressForm.value?.emailAddress}}
                                </p>
                              </span>
                              <span>
                                <label>
                                  Phone no:
                                </label>
                                <p>
                                  {{addressForm.value?.phoneNumber | mask: '(000) 000-0000'}}
                                </p>
                              </span>
                              <span>
                                <label>
                                  Address:
                                </label>
                                <p>
                                  {{addressForm.value?.address}}
                                </p>
                              </span>
                              <span>
                                <label>
                                  Agreement No:
                                </label>
                                <p>
                                  {{agreementNumberForm.value.agreementNumber}}
                                </p>
                              </span>
                            </div>
                      
                            <div class="product_detailsection">
                              <h3>{{coverItemDetails?.title}}</h3>
                              <img [src]="coverItemDetails?.image" alt="coverItem" height="50px" width="50px">
                              <!-- <span *ngIf="coverItemDetails?.standardPrice">
                              $ {{coverItemDetails?.standardPrice | number}}
                              </span> -->
                            </div>
                            <div class="coverprt">
                              <div  class="carouselPrt">
                                <div class="crousel_arrow">
                                  <div [ngClass]="
                                          'arrow arrow--left ' + (currentSlide === 0 ? 'arrow--disabled' : '')
                                      "
                                      (click)="slider?.prev()"></div>
                                      <div *ngIf="slider" [ngClass]="
                                          'arrow arrow--right ' +
                                          (slider.track.details.slides.length - 1 === currentSlide
                                          ? 'arrow--disabled'
                                          : '')
                                      "
                                      (click)="slider.next()"
                                      ></div>
                                </div>
                                <div class="keen-slider" #sliderRef>
                                    <div class="keen-slider__slide number-slide{{0}}" *ngIf="coverItemDetails?.whatWeCover">
                                        <div class="coveragestage">
                                            <h3>What is covered?</h3>
                                            <p>
                                              {{coverItemDetails?.whatWeCover}}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="keen-slider__slide number-slide{{1}}" *ngIf="coverItemDetails?.notCovered">
                                        <div class="coveragestage">
                                            <h3>What is not covered?</h3>
                                            <p>
                                                {{coverItemDetails?.notCovered}}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="keen-slider__slide number-slide{{2}}" *ngIf="coverItemDetails?.additionalInformation">
                                        <div class="coveragestage">
                                            <h3>Additional information</h3>
                                            <p>
                                                {{coverItemDetails?.additionalInformation}}
                                            </p>
                                        </div>
                                    </div>
                                </div> 
                              </div>
                              <div class="coverage" *ngIf="coverItemDetails?.maximumCoverage">
                                <h2>MAXIMUM COVERAGE</h2>
                                <span>{{coverItemDetails?.maximumCoverage ? (coverItemDetails?.maximumCoverage) : ''}}</span>
                              </div>
                            </div>
                            
        
                            <div class="questionaddedarea">
                            
                              <div class="accordianprt">
                                <div class="prtaccordian">
                                  <h4 *ngIf="beforeQuestionAnswer?.length">Additional Information</h4>
                                  <mat-accordion>
                                    <ng-container *ngFor="let item of beforeQuestionAnswer">
                                      <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false" *ngIf="item?.answer">
                                        <mat-expansion-panel-header>
                                          <mat-panel-title>
                                          {{item?.question}}
                                          </mat-panel-title>
                                      
                                        </mat-expansion-panel-header>
                                        <p>{{item?.answer}}</p>
                                      </mat-expansion-panel>
                                    </ng-container>
                                  
                                  </mat-accordion>
                                </div>
                                <div class="prtaccordian">
                                  <h4 *ngIf="!beforeQuestionAnswer?.length && claimQuestionAnswer?.length">Additional Information</h4>
                                  <mat-accordion>
                                    <ng-container *ngFor="let item of claimQuestionAnswer">
                                      <mat-expansion-panel  (opened)="panelOpenState = true" (closed)="panelOpenState = false"  *ngIf="item?.answer">
                                        <mat-expansion-panel-header>
                                          <mat-panel-title>
                                          {{item?.question}}
                                          </mat-panel-title>
                                      
                                        </mat-expansion-panel-header>
                                        <ng-container *ngFor="let answer of item?.answer">
                                          <p>{{answer}}</p>
                                        </ng-container>
                                      <p *ngIf="otherAnswerForm.value.isOtherAnswer">{{otherAnswerForm.value?.otherAnswer}}</p>
                                      </mat-expansion-panel>
                                    </ng-container>
                                    
                                  </mat-accordion>
                                </div>
                                <div class="prtaccordian" *ngIf="issueDateForm.value?.issueDate && claimQuestionAnswer?.length">
                                  <mat-accordion>
                                      <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                                        <mat-expansion-panel-header>
                                          <mat-panel-title>
                                            When did you first notice the issue?
                                          </mat-panel-title>
                                        </mat-expansion-panel-header>
                                       <p>{{issueDateForm.value.issueDate | date : 'YYYY-MMM-dd'}}</p>
                                      </mat-expansion-panel>
                                  </mat-accordion>
                                </div>
                                <div class="prtaccordian">
                                  <mat-accordion >
                                    <ng-container *ngFor="let item of afterQuestionAnswer">
                                      <mat-expansion-panel  (opened)="panelOpenState = true" (closed)="panelOpenState = false" *ngIf="item?.answer" >
                                        <mat-expansion-panel-header>
                                          <mat-panel-title>
                                          {{item?.question}}
                                          </mat-panel-title>
                                      
                                        </mat-expansion-panel-header>
                                        <p>{{item?.answer}}</p>
                                      </mat-expansion-panel>
                                    </ng-container>
                                    
                                  </mat-accordion>
                                </div>
                  
                              </div>
                            </div>
                            <div *ngIf="timeForm.controls['copaymentFee'].value && timeForm.valid" class="copayfeearea">
                              Copayment Fee ${{timeForm.controls['copaymentFee'].value}}
                            </div>
                      
                      
                          </div>
                      
                          
                      </div>
                </div>
                
               </div>
                
        
                  <!-- STEP 5 -->
        
                  <div class="successmsg" *ngIf="step == 5">
                    <h2 class="heading main__heading">
                      HELP IS ON THE WAY!
                    </h2>
                      <img ngSrc="https://cdn.elitehw.com/images/big-tick.webp" alt="big-tick" class="freequteicon" width="50" height="50">
                      <p>
                        We are now processing your claim. A claims concierge will be in touch with you shortly to schedule the repair. We look
                        forward to providing you with a great service experience. Thank you for being a valued member.
                      </p>
                      <p>Your Claim Number is <b>{{fileClaimNumber}}</b></p>
                      <h3>
                        Do what you love. We take care of where you live.
                      </h3>
                  </div>
        
                  <div class="stepper">
                    <div class="stepperpoint" [style.width]="step == 0 && fileClaimSubSteps === fileClaimSubStep.AgreementGridPage ? '2%' : step == 0 && fileClaimSubSteps === fileClaimSubStep.AgreementNumberPage ? '5%' : step == 1 && !submitFullForm ? '10%' : step == 1 && submitFullForm ? '20%' : step == 2 ? '40%' : step == 3 ? '60%' : step == 4 ? '80%' : step == 5 ? '100%' : '0%' "></div>
                  </div>
            </div>
          
        </div>
      </div>
    </div>
  </fury-page-layout-content>
</fury-page-layout>










  
